videojs.addLanguage('ja', {
  "Audio Player": "オーディオプレイヤー",
  "Video Player": "ビデオプレイヤー",
  "Play": "再生",
  "Pause": "一時停止",
  "Replay": "もう一度見る",
  "Current Time": "現在の時間",
  "Duration": "長さ",
  "Remaining Time": "残りの時間",
  "Stream Type": "ストリームの種類",
  "LIVE": "ライブ",
  "Loaded": "ロード済み",
  "Progress": "進行状況",
  "Progress Bar": "シークバー",
  "progress bar timing: currentTime={1} duration={2}": "{2}の{1}",
  "Fullscreen": "フルスクリーン",
  "Non-Fullscreen": "フルスクリーン以外",
  "Mute": "ミュート",
  "Unmute": "ミュート解除",
  "Playback Rate": "再生レート",
  "Subtitles": "サブタイトル",
  "subtitles off": "サブタイトル オフ",
  "Captions": "キャプション",
  "captions off": "キャプション オフ",
  "Chapters": "チャプター",
  "Descriptions": "ディスクリプション",
  "descriptions off": "ディスクリプションオフ",
  "Audio Track": "音声トラック",
  "Volume Level": "ボリュームレベル",
  "You aborted the media playback": "動画再生を中止しました",
  "A network error caused the media download to fail part-way.": "ネットワーク エラーにより動画のダウンロードが途中で失敗しました",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "サーバーまたはネットワークのエラー、またはフォーマットがサポートされていないため、動画をロードできませんでした",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "破損の問題、またはお使いのブラウザがサポートしていない機能が動画に使用されていたため、動画の再生が中止されました",
  "No compatible source was found for this media.": "この動画に対して互換性のあるソースが見つかりませんでした",
  "The media is encrypted and we do not have the keys to decrypt it.": "メディアは暗号化されており、解読するためのキーがありません。",
  "Play Video": "ビデオを再生する",
  "Close": "閉じる",
  "Close Modal Dialog": "ダイアログボックスを閉じる",
  "Modal Window": "ダイアログボックス",
  "This is a modal window": "これはダイアログボックスです",
  "This modal can be closed by pressing the Escape key or activating the close button.": "このダイアログボックスは、Escキーを押すか、閉じるボタンを押して閉じることができま",
  ", opens captions settings dialog": ", 書き起こし字幕の設定を開く",
  ", opens subtitles settings dialog": ", 字幕の設定を開く",
  ", opens descriptions settings dialog": ", ディスクリプションの設定を開く",
  ", selected": ", 選択済み",
  "captions settings": "書き起こし字幕の設定",
  "subtitles settings": "字幕の設定",
  "descriptions settings": "ディスクリプションの設定",
  "Text": "テキスト",
  "White": "白",
  "Black": "黒",
  "Red": "赤",
  "Green": "緑",
  "Blue": "青",
  "Yellow": "黄",
  "Magenta": "赤紫",
  "Cyan": "シアン",
  "Background": "背景",
  "Window": "ウィンドウ",
  "Transparent": "透明",
  "Semi-Transparent": "半透明",
  "Opaque": "不透明",
  "Font Size": "文字サイズ",
  "Text Edge Style": "テキストのアウトラインのスタイル",
  "None": "なし",
  "Uniform": "均一",
  "Dropshadow": "影付き",
  "Font Family": "フォントの種類",
  "Proportional Sans-Serif": "セリフなし可変幅フォント",
  "Monospace Sans-Serif": "セリフなし等幅フォント",
  "Proportional Serif": "セリフあり可変幅フォント",
  "Monospace Serif": "セリフあり等幅フォント",
  "Small Caps": "スモールキャピタル",
  "Reset": "リセット",
  "restore all settings to the default values": "すべての設定をデフォルト値に戻す",
  "Done": "終了",
  "Caption Settings Dialog": "書き起こし字幕設定ダイアログ",
  "Beginning of dialog window. Escape will cancel and close the window.": "ダイアログボックスの開始。Escキーでキャンセルしてウィンドウを閉じます。",
  "End of dialog window.": "ダイアログボックスの終了",
  "{1} is loading.": "{1}は読み込み中です。",
  "Exit Picture-in-Picture": "ピクチャーインピクチャー機能の終了",
  "Picture-in-Picture": "ピクチャーインピクチャー"
});